var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"metadata-btn",style:('opacity:' + _vm.category.style['fill-opacity'] + ';'),attrs:{"x-small":"","rounded":"","color":_vm.category.style.fill}}),_vm._v("\n  "+_vm._s(_vm.category.label)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }